// import React, { useEffect, useState } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
// import { getBase64ImageFromUrl } from "./Utils";
import idbApi from "../api/IdbApi.js";
import { CUSTOMER_TBL, PRODUCT_TBL } from "../contexts/IndexedDB.js";
import bg_img from "../data/letterhead.png";

pdfMake.vfs = pdfFonts;

const formatCurrency = (number) => {
  return number.toLocaleString("en-PK", {
    style: "currency",
    currency: "PKR",
    minimumFractionDigits: 2,
  });
};

const toBase64 = (url) =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        })
    );

const generateInvoice = async (
  so_id,
  customer_id,
  storee,
  username1,
  orgname1,
  type1,
  o_datetime,
  project_name,
  ship_method,
  shipment1,
  so_note,
  tax1,
  total_price,
  cart
) => {
  var dP = new Date();
  var dI = new Date(o_datetime);
  //   console.log(cart);
  const custss = await idbApi.getAllNow(CUSTOMER_TBL);
  const custome = custss.find((cus) => cus.customer_id === customer_id);
  //   console.log(custome);

  const cartItems = [];
  for (let i = 0; i < cart.length; i++) {
    const prodd = await idbApi.getAllFilterProductId(
      cart[i].product_id,
      PRODUCT_TBL
    );
    // console.log(prodd);
    const saleProduct = {
      item_no: i + 1,
      name:
        cart[i].item_note === ""
          ? prodd[0].productname
          : cart[i].item_note + " - " + prodd[0].productname,
      quantity: cart[i].quantity,
      price: parseInt(cart[i].price) || 0,
      discount: parseInt(cart[i].discount) || 0,
    };
    cartItems.push(saleProduct);
  }
  //   console.log(cartItems);

  const userName = username1 || "N/A";
  const orgName = orgname1 || "N/A";
  const storeName = storee || "N/A";
  const type = type1 || "N/A";
  const custName = custome.customer || "N/A";
  const invoiceId = so_id || "N/A";
  const invoiceDate = o_datetime
    ? o_datetime.slice(-2) === "PM" || o_datetime.slice(-2) === "AM"
      ? o_datetime
      : `${dI.getDate().toString().padStart(2, "0")}-${(dI.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${dI.getFullYear()} ${dI
          .getHours()
          .toString()
          .padStart(2, "0")}:${dI.getMinutes().toString().padStart(2, "0")}`
    : "N/A";
  const projectName = project_name || "";
  const shipMethod = ship_method || "";
  const tax = tax1 || 0;
  const shipment = shipment1 || 0;
  const discount = cartItems.reduce((n, { discount }) => n + discount, 0) || 0;
  const totalPrice = total_price || 0;
  const prevBal = 0;
  const newBal = 0;
  const typeId = custome.type_id || 1600;
  const phone = custome.phone || "";
  const note = so_note || "";

  const bgImage = await toBase64(bg_img);

  const tableBody = [
    [
      {
        text: "#",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Item Description",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Qty",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Unit Price",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Discount",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Total",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
    ],
    ...cartItems.map((item, i) => [
      { text: `${item.item_no}.`, alignment: "center", fontSize: 9.5 },
      { text: item.name, alignment: "left", fontSize: 9.5 },
      {
        text: item.quantity.toString(),
        alignment: "center",
        fontSize: 9.5,
      },
      {
        text: `${item.price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        alignment: "right",
        fontSize: 9.5,
      },
      {
        text: `${item.discount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        alignment: "right",
        fontSize: 9.5,
      },
      {
        text: `${(item.quantity * (item.price - item.discount))
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        alignment: "right",
        fontSize: 9.5,
      },
    ]),
  ];
  // const totalAmount = items.reduce(
  //   (sum, item) => sum + item.quantity * item.price,
  //   0
  // );

  var subTotal =
    (100 * (totalPrice + discount - shipment) + discount * tax) / (tax + 100);

  const docDefinition = {
    pageSize: "A4",
    pageMargins: [40, 60, 40, 60],
    // background: [
    //   {
    //     image: bgImage,
    //     width: 595.28, // A4 width in points
    //     height: 841.89, // A4 height in points
    //   },
    // ],
    content: [
      // {
      //   columns: [
      //     // company.logo
      //     //   ? {
      //     //       image: company.logo,
      //     //       width: 100,
      //     //     }
      //     //   : {},
      //     [
      //       { text: company.name, style: "companyName" },
      //       { text: company.address },
      //       { text: company.phone },
      //       { text: company.email },
      //     ],
      //   ],
      // },
      {
        columns: [
          { text: orgName, style: "header1" },
          { text: "Sale Invoice", style: "header2" },
        ],
      },
      {
        columns: [
          [
            { text: "Bill To:", style: "subheader" },
            {
              text:
                projectName !== ""
                  ? `${custName} (${projectName})`
                  : `${custName}`,
              fontSize: 11,
            },
            { text: phone, fontSize: 11 },
            { text: shipMethod, fontSize: 11 },
          ],
          [
            {
              text: `Store: ` + storeName,
              alignment: "right",
              margin: [0, 5, 0, 5],
              fontSize: 11,
            },
            {
              text: `Invoice # S${invoiceId}`,
              alignment: "right",
              fontSize: 11,
            },
            {
              text: `Date: ${invoiceDate}`,
              alignment: "right",
              fontSize: 11,
            },
            //   { text: `Due: ${invoice.dueDate}`, alignment: "right" },
          ],
        ],
      },
      {
        table: {
          headerRows: 1,
          widths: ["auto", "*", "auto", "auto", "auto", "auto"],
          body: tableBody,
        },
        margin: [0, 15, 0, 0],
        fontSize: 10,
      },
      {
        columns: [
          { text: "" },
          {
            table: {
              widths: ["*", "auto"],
              body: [
                [
                  {
                    text: "Subtotal:",
                    alignment: "right",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: `${(Math.round(subTotal * 1000) / 1000)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                    alignment: "right",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                ],
                ...(discount > 0
                  ? [
                      [
                        {
                          text: "Discount:",
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                        {
                          text: `${(Math.round(discount * 1000) / 1000)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                      ],
                    ]
                  : []),
                ...(tax > 0
                  ? [
                      [
                        {
                          text: `Tax (${tax}%):`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                        {
                          text: `${(
                            Math.round(
                              ((tax * (subTotal - discount)) / 100) * 1000
                            ) / 1000
                          )
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                      ],
                    ]
                  : []),
                ...(shipment > 0
                  ? [
                      [
                        {
                          text: `Shipping:`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                        {
                          text: `${(Math.round(shipment * 1000) / 1000)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                      ],
                    ]
                  : []),
                [
                  {
                    text: "Grand Total:",
                    bold: true,
                    alignment: "right",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: `${formatCurrency(
                      Math.round(totalPrice * 1000) / 1000
                    )}`,
                    bold: true,
                    alignment: "right",
                    fontSize: 10,
                    border: [false, true, false, true],
                  },
                ],
                ...(type === "New" && typeId !== 1600
                  ? [
                      [
                        {
                          text: "Previous Balance:",
                          alignment: "right",
                          fontSize: 10,
                          margin: [0, 5, 0, 0],
                          border: [false, false, false, false],
                        },
                        {
                          text:
                            prevBal < 0
                              ? `(${(Math.round(-1 * prevBal * 1000) / 1000)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")})`
                              : `${(Math.round(prevBal * 1000) / 1000)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                          alignment: "right",
                          fontSize: 10,
                          margin: [0, 5, 0, 0],
                          border: [false, false, false, false],
                        },
                      ],
                    ]
                  : []),
                ...(type === "New" && typeId !== 1600
                  ? [
                      [
                        {
                          text: "New Balance:",
                          bold: true,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                        {
                          text:
                            newBal < 0
                              ? `(${(Math.round(-1 * newBal * 1000) / 1000)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")})`
                              : `${(Math.round(newBal * 1000) / 1000)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                          bold: true,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                      ],
                    ]
                  : []),
              ],
            },
          },
        ],
        margin: [0, 10, 0, 0],
      },
      {
        columns: [
          [
            {
              text: "Notes:",
              fontSize: 11,
              bold: true,
              margin: [0, 20, 0, 5],
            },
            { text: note, fontSize: 10 },
          ],
        ],
      },
      // {
      //   text: "Thank you for shopping with us!",
      //   style: "footer",
      //   margin: [0, 40, 0, 0],
      // },
    ],
    styles: {
      header1: {
        fontSize: 18,
        bold: true,
        alignment: "left",
        margin: [0, 0, 0, 5],
      },
      header2: {
        fontSize: 18,
        bold: true,
        alignment: "right",
        margin: [0, 0, 0, 5],
      },
      subheader: { fontSize: 11, bold: true, margin: [0, 5, 0, 5] },
      companyName: { fontSize: 14, bold: true },
      footer: { alignment: "center", italics: true },
    },

    footer: function (currentPage, pageCount) {
      return {
        columns: [
          {
            text: `User: ${userName}`,
            alignment: "left",
            margin: [40, 0, 0, 0],
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "center",
          },
          {
            text: `Printed: ${dP.getDate().toString().padStart(2, "0")}-${(
              dP.getMonth() + 1
            )
              .toString()
              .padStart(2, "0")}-${dP.getFullYear()} ${dP
              .getHours()
              .toString()
              .padStart(2, "0")}:${dP
              .getMinutes()
              .toString()
              .padStart(2, "0")}`,
            alignment: "right",
            margin: [0, 0, 40, 0],
          },
        ],
        fontSize: 9.5,
      };
    },
  };

  //   pdfMake.createPdf(docDefinition).print();
  return new Promise((resolve, reject) => {
    try {
      console.log("1");
      pdfMake.createPdf(docDefinition).getBlob((blob) => {
        resolve(blob); // return the PDF Blob
      });
    } catch (err) {
      reject(err);
    }
  });
};

const generatePackingList = async (
  so_id,
  customer_id,
  storee,
  username1,
  orgname1,
  o_datetime,
  project_name,
  ship_method,
  so_note,
  cart
) => {
  var dP = new Date();
  var dI = new Date(o_datetime);
  const custss = await idbApi.getAllNow(CUSTOMER_TBL);
  const custome = custss.find((cus) => cus.customer_id === customer_id);

  const cartItems = [];
  for (let i = 0; i < cart.length; i++) {
    const prodd = await idbApi.getAllFilterProductId(
      cart[i].product_id,
      PRODUCT_TBL
    );
    const saleProduct = {
      item_no: i + 1,
      name: prodd[0].productname,
      quantity: cart[i].quantity,
      note: cart[i].item_note,
    };
    cartItems.push(saleProduct);
  }

  const userName = username1 || "N/A";
  const orgName = orgname1 || "N/A";
  const storeName = storee || "N/A";
  const custName = custome.customer || "N/A";
  const invoiceId = so_id || "N/A";
  const invoiceDate = o_datetime
    ? o_datetime.slice(-2) === "PM" || o_datetime.slice(-2) === "AM"
      ? o_datetime
      : `${dI.getDate().toString().padStart(2, "0")}-${(dI.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${dI.getFullYear()} ${dI
          .getHours()
          .toString()
          .padStart(2, "0")}:${dI.getMinutes().toString().padStart(2, "0")}`
    : "N/A";
  const projectName = project_name || "";
  const shipMethod = ship_method || "";
  const phone = custome.phone || "";
  const note = so_note || "";

  const tableBody = [
    [
      {
        text: "#",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Item Description",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Qty",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Item Note",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
    ],
    ...cartItems.map((item, i) => [
      { text: `${item.item_no}.`, alignment: "center", fontSize: 9.5 },
      { text: item.name, alignment: "left", fontSize: 9.5 },
      {
        text: item.quantity.toString(),
        alignment: "center",
        fontSize: 9.5,
      },
      { text: item.note, alignment: "left", fontSize: 9.5 },
    ]),
  ];

  const docDefinition = {
    pageSize: "A4",
    pageMargins: [40, 60, 40, 60],
    content: [
      {
        columns: [
          { text: orgName, style: "header1" },
          { text: "Packing List", style: "header2" },
        ],
      },
      {
        columns: [
          [
            { text: "Bill To:", style: "subheader" },
            {
              text:
                projectName !== ""
                  ? `${custName} (${projectName})`
                  : `${custName}`,
              fontSize: 11,
            },
            { text: phone, fontSize: 11 },
            { text: shipMethod, fontSize: 11 },
          ],
          [
            {
              text: `Store: ` + storeName,
              alignment: "right",
              margin: [0, 5, 0, 5],
              fontSize: 11,
            },
            {
              text: `Invoice # S${invoiceId}`,
              alignment: "right",
              fontSize: 11,
            },
            {
              text: `Date: ${invoiceDate}`,
              alignment: "right",
              fontSize: 11,
            },
            //   { text: `Due: ${invoice.dueDate}`, alignment: "right" },
          ],
        ],
      },
      {
        table: {
          headerRows: 1,
          widths: ["auto", "*", "auto", "auto"],
          body: tableBody,
        },
        margin: [0, 15, 0, 0],
        fontSize: 10,
      },
      {
        columns: [
          [
            {
              text: "Notes:",
              fontSize: 11,
              bold: true,
              margin: [0, 20, 0, 5],
            },
            { text: note, fontSize: 10 },
          ],
        ],
      },
    ],
    styles: {
      header1: {
        fontSize: 18,
        bold: true,
        alignment: "left",
        margin: [0, 0, 0, 5],
      },
      header2: {
        fontSize: 18,
        bold: true,
        alignment: "right",
        margin: [0, 0, 0, 5],
      },
      subheader: { fontSize: 11, bold: true, margin: [0, 5, 0, 5] },
      companyName: { fontSize: 14, bold: true },
      footer: { alignment: "center", italics: true },
    },

    footer: function (currentPage, pageCount) {
      return {
        columns: [
          {
            text: `User: ${userName}`,
            alignment: "left",
            margin: [40, 0, 0, 0],
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "center",
          },
          {
            text: `Printed: ${dP.getDate().toString().padStart(2, "0")}-${(
              dP.getMonth() + 1
            )
              .toString()
              .padStart(2, "0")}-${dP.getFullYear()} ${dP
              .getHours()
              .toString()
              .padStart(2, "0")}:${dP
              .getMinutes()
              .toString()
              .padStart(2, "0")}`,
            alignment: "right",
            margin: [0, 0, 40, 0],
          },
        ],
        fontSize: 9.5,
      };
    },
  };

  return new Promise((resolve, reject) => {
    try {
      pdfMake.createPdf(docDefinition).getBlob((blob) => {
        resolve(blob); // return the PDF Blob
      });
    } catch (err) {
      reject(err);
    }
  });
};

const generateEstimate = async (
  so_id,
  customer_id,
  storee,
  username1,
  orgname1,
  // type1,
  o_datetime,
  project_name,
  ship_method,
  shipment1,
  so_note,
  tax1,
  total_price,
  cart
) => {
  var dP = new Date();
  var dI = new Date(o_datetime);
  //   console.log(cart);
  const custss = await idbApi.getAllNow(CUSTOMER_TBL);
  const custome = custss.find((cus) => cus.customer_id === customer_id);
  //   console.log(custome);

  const cartItems = [];
  for (let i = 0; i < cart.length; i++) {
    const prodd = await idbApi.getAllFilterProductId(
      cart[i].product_id,
      PRODUCT_TBL
    );
    // console.log(prodd);
    const saleProduct = {
      item_no: i + 1,
      name:
        cart[i].item_note === ""
          ? prodd[0].productname
          : cart[i].item_note + " - " + prodd[0].productname,
      quantity: cart[i].quantity,
      price: parseInt(cart[i].price) || 0,
      discount: parseInt(cart[i].discount) || 0,
    };
    cartItems.push(saleProduct);
  }
  //   console.log(cartItems);

  const userName = username1 || "N/A";
  const orgName = orgname1 || "N/A";
  const storeName = storee || "N/A";
  // const type = type1 || "N/A";
  const custName = custome.customer || "N/A";
  const invoiceId = so_id || "N/A";
  const invoiceDate = o_datetime
    ? o_datetime.slice(-2) === "PM" || o_datetime.slice(-2) === "AM"
      ? o_datetime
      : `${dI.getDate().toString().padStart(2, "0")}-${(dI.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${dI.getFullYear()} ${dI
          .getHours()
          .toString()
          .padStart(2, "0")}:${dI.getMinutes().toString().padStart(2, "0")}`
    : "N/A";
  const projectName = project_name || "";
  const shipMethod = ship_method || "";
  const tax = tax1 || 0;
  const shipment = shipment1 || 0;
  const discount = cartItems.reduce((n, { discount }) => n + discount, 0) || 0;
  const totalPrice = total_price || 0;
  // const prevBal = 0;
  // const newBal = 0;
  // const typeId = custome.type_id || 1600;
  const phone = custome.phone || "";
  const note = so_note || "";

  const tableBody = [
    [
      {
        text: "#",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Item Description",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Qty",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Unit Price",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Discount",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
      {
        text: "Total",
        bold: true,
        alignment: "center",
        fillColor: "#eeeeee",
        fontSize: 10.5,
      },
    ],
    ...cartItems.map((item, i) => [
      { text: `${item.item_no}.`, alignment: "center", fontSize: 9.5 },
      { text: item.name, alignment: "left", fontSize: 9.5 },
      {
        text: item.quantity.toString(),
        alignment: "center",
        fontSize: 9.5,
      },
      {
        text: `${item.price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        alignment: "right",
        fontSize: 9.5,
      },
      {
        text: `${item.discount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        alignment: "right",
        fontSize: 9.5,
      },
      {
        text: `${(item.quantity * (item.price - item.discount))
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        alignment: "right",
        fontSize: 9.5,
      },
    ]),
  ];
  // const totalAmount = items.reduce(
  //   (sum, item) => sum + item.quantity * item.price,
  //   0
  // );

  var subTotal =
    (100 * (totalPrice + discount - shipment) + discount * tax) / (tax + 100);

  const docDefinition = {
    pageSize: "A4",
    pageMargins: [40, 60, 40, 60],
    content: [
      // {
      //   columns: [
      //     // company.logo
      //     //   ? {
      //     //       image: company.logo,
      //     //       width: 100,
      //     //     }
      //     //   : {},
      //     [
      //       { text: company.name, style: "companyName" },
      //       { text: company.address },
      //       { text: company.phone },
      //       { text: company.email },
      //     ],
      //   ],
      // },
      {
        columns: [
          { text: orgName, style: "header1" },
          { text: "Quotation", style: "header2" },
        ],
      },
      {
        columns: [
          [
            { text: "Bill To:", style: "subheader" },
            {
              text:
                projectName !== ""
                  ? `${custName} (${projectName})`
                  : `${custName}`,
              fontSize: 11,
            },
            { text: phone, fontSize: 11 },
            { text: shipMethod, fontSize: 11 },
          ],
          [
            {
              text: `Store: ` + storeName,
              alignment: "right",
              margin: [0, 5, 0, 5],
              fontSize: 11,
            },
            {
              text: `Invoice # S${invoiceId}`,
              alignment: "right",
              fontSize: 11,
            },
            {
              text: `Date: ${invoiceDate}`,
              alignment: "right",
              fontSize: 11,
            },
            //   { text: `Due: ${invoice.dueDate}`, alignment: "right" },
          ],
        ],
      },
      {
        table: {
          headerRows: 1,
          widths: ["auto", "*", "auto", "auto", "auto", "auto"],
          body: tableBody,
        },
        margin: [0, 15, 0, 0],
        fontSize: 10,
      },
      {
        columns: [
          { text: "" },
          {
            table: {
              widths: ["*", "auto"],
              body: [
                [
                  {
                    text: "Subtotal:",
                    alignment: "right",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: `${(Math.round(subTotal * 1000) / 1000)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                    alignment: "right",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                ],
                ...(discount > 0
                  ? [
                      [
                        {
                          text: "Discount:",
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                        {
                          text: `${(Math.round(discount * 1000) / 1000)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                      ],
                    ]
                  : []),
                ...(tax > 0
                  ? [
                      [
                        {
                          text: `Tax (${tax}%):`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                        {
                          text: `${(
                            Math.round(
                              ((tax * (subTotal - discount)) / 100) * 1000
                            ) / 1000
                          )
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                      ],
                    ]
                  : []),
                ...(shipment > 0
                  ? [
                      [
                        {
                          text: `Shipping:`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                        {
                          text: `${(Math.round(shipment * 1000) / 1000)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
                          alignment: "right",
                          fontSize: 10,
                          border: [false, false, false, false],
                        },
                      ],
                    ]
                  : []),
                [
                  {
                    text: "Grand Total:",
                    bold: true,
                    alignment: "right",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: `${formatCurrency(
                      Math.round(totalPrice * 1000) / 1000
                    )}`,
                    bold: true,
                    alignment: "right",
                    fontSize: 10,
                    border: [false, true, false, true],
                  },
                ],
              ],
            },
          },
        ],
        margin: [0, 10, 0, 0],
      },
      {
        columns: [
          [
            {
              text: "Notes:",
              fontSize: 11,
              bold: true,
              margin: [0, 20, 0, 5],
            },
            { text: note, fontSize: 10 },
          ],
        ],
      },
      // {
      //   text: "Thank you for shopping with us!",
      //   style: "footer",
      //   margin: [0, 40, 0, 0],
      // },
    ],
    styles: {
      header1: {
        fontSize: 18,
        bold: true,
        alignment: "left",
        margin: [0, 0, 0, 5],
      },
      header2: {
        fontSize: 18,
        bold: true,
        alignment: "right",
        margin: [0, 0, 0, 5],
      },
      subheader: { fontSize: 11, bold: true, margin: [0, 5, 0, 5] },
      companyName: { fontSize: 14, bold: true },
      footer: { alignment: "center", italics: true },
    },

    footer: function (currentPage, pageCount) {
      return {
        columns: [
          {
            text: `User: ${userName}`,
            alignment: "left",
            margin: [40, 0, 0, 0],
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "center",
          },
          {
            text: `Printed: ${dP.getDate().toString().padStart(2, "0")}-${(
              dP.getMonth() + 1
            )
              .toString()
              .padStart(2, "0")}-${dP.getFullYear()} ${dP
              .getHours()
              .toString()
              .padStart(2, "0")}:${dP
              .getMinutes()
              .toString()
              .padStart(2, "0")}`,
            alignment: "right",
            margin: [0, 0, 40, 0],
          },
        ],
        fontSize: 9.5,
      };
    },
  };

  return new Promise((resolve, reject) => {
    try {
      pdfMake.createPdf(docDefinition).getBlob((blob) => {
        resolve(blob); // return the PDF Blob
      });
    } catch (err) {
      reject(err);
    }
  });
};

export { generateInvoice, generatePackingList, generateEstimate };
